import { useState, useEffect } from 'react'
import { ChallengeType } from '../model/model'
import { challengeAdapter, getChallengeEntityID } from '../store/challengeSlice'
import { useAppSelector } from '../store/store'

const useChallengeSelector = (beltID?: number): Array<ChallengeType> | undefined => {
  const [data, setData] = useState<Array<ChallengeType>>([])

  const selectors = challengeAdapter.getSelectors()
  const state = useAppSelector((store) => store.challenge.challenges)

  useEffect(() => {
    if (beltID) {
      const challenge = selectors.selectById(state, getChallengeEntityID(beltID))

      if (challenge && challenge.data) {
        setData(challenge.data)
      } else {
        setData((prev) => {
          if (prev.length) {
            return []
          }

          return prev
        })
      }
    }
  }, [beltID, selectors, state])

  return data
}

export default useChallengeSelector
